@if (isLoaded){
@if (eventOpen){

<div class="row section__header">
    <div class="col-12">
        <h1 class="text-center font-weight-bold">SELECT YOUR THERAPIST</h1>
    </div>
</div>
<div class="row section__header">
    <div class="col-12">
        <h3 class="text-center font-weight-bold text-uppercase mb-0">{{eventName}}</h3>
        <p class="text-center text-uppercase">{{eventStartDate|date:'dd MMM YYYY'}} - {{eventEndDate|date:'dd MMM YYYY'}}</p>
    </div>
</div>




<div class="row">

    <!-- Loop over each iteration of available therapists -->
    <!-- Selecting the therapist would allow user to book the selected therapist -->
    <!-- Also an option to select any therapist - next available -->
    <div class="col-12">
        <button (click)="selectTherapist();" class="select-therapist__button" mat-stroked-button>
            <div class="row">
                <div class="col">
                    <img class="rounded-pill img-fluid" style="max-height: 60px; aspect-ratio: 1/1;"
                         src="https://res.cloudinary.com/coolcodecompany/image/upload/c_thumb,g_face,w_767,h_767/v11/winning_hands/therapists/any.png">
                </div>
                <div class="col-auto d-flex align-items-center">
                    <p class="mb-0">Next available therapist</p>
                </div>
            </div>
        </button>
    </div>

    <p class="mb-0 mt-4">Or select a specific therapist below</p>
    @for (therapist of therapists; track therapist.therapistId){
    <div class="col-12">
        @if (therapist.therapistStatusId && therapist.therapistId){
        <button [disabled]="(therapist.therapistStatusId === 1 || therapist.therapistStatusId === 2 || therapist.therapistStatusId === 5) && (!therapist.startTime && !therapist.endTime) || !therapist.acceptBookings" (click)="selectTherapist(therapist);"
                class="select-therapist__button" mat-stroked-button>
            <div class="row">
                <div class="col">
                    <img class="rounded-pill img-fluid" style="max-height: 60px; aspect-ratio: 1/1;" src="{{getThumbURL(therapist.profileLargeURL)}}">

                    @if ((therapist.therapistStatusId !== 1 && therapist.therapistStatusId !== 2 && therapist.therapistStatusId !== 5) && therapist.acceptBookings)
                    {
                    <span style="width: 18px; height: 18px; border: 2px solid white; border-radius: 19px; background: green; position: absolute; bottom: 0;left: 46px;"></span>
                    } @else if (therapist.startTime && therapist.endTime){
                    <span style="width: 18px; height: 18px; border: 2px solid white; border-radius: 19px; background: orange; position: absolute; bottom: 0;left: 46px;"></span>
                    } @else {
                    <span style="width: 18px; height: 18px; border: 2px solid white; border-radius: 19px; background: red; position: absolute; bottom: 0;left: 46px;"></span>
                    }


                </div>
                <div class="col-auto d-flex align-items-center">
                    <p style="text-align: left;" class="mb-0">
                        {{ getDisplayName(therapist) }}
                        <br />
                        @if ((therapist.therapistStatusId !== 1 && therapist.therapistStatusId !== 2 && therapist.therapistStatusId !== 5) && therapist.acceptBookings){
                        <span class="badge text-bg-secondary">{{therapist.availableStatus}}</span>
                        } @else if (therapist.startTime && therapist.endTime){
                        <span class="badge text-bg-secondary">Scheduled between {{therapist.startTime}} & {{therapist.endTime}}</span>
                        }
                        @else {
                        <span class="badge text-bg-secondary">Not Available</span>
                        }
                    </p>
                </div>
            </div>
        </button>
        }

    </div>
    }
</div>
}
@else {
<div class="row section__header">
    <div class="col-12 text-center">
        <span class="material-symbols-outlined hand-icon mb-3">waving_hand</span>
        <h1 class="text-center font-weight-bold">SORRY WE ARE NOT OPEN FOR BOOKINGS</h1>
        <p class="text-center font-weight-bold">Please check back later</p>
    </div>
</div>
}
}
@else {
<div class="wh-loading-bar">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

}
